module.exports = __webpack_public_path__ + "img/firstfeatureicon.fa79d33c.webp";